import React, { useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import useOutsideClick from '../../hooks/useOutsideClick'

const ActionButton = ({
  actions,
  icon,
  index,
  activeIndex,
  setActiveIndex,
  disabled,
}) => {
  const dropdownRef = useRef(null)
  const [dropdownPosition, setDropdownPosition] = React.useState({
    top: 0,
    left: 0,
  })

  const toggleDropdown = event => {
    event.stopPropagation()

    if (activeIndex === index) {
      setActiveIndex(null)
    } else {
      const rect = event.currentTarget.getBoundingClientRect()
      setDropdownPosition({
        top: rect.top + window.scrollY + 20,
        left: rect.left - 150 + window.scrollX,
      })
      setActiveIndex(index)
    }
  }

  useOutsideClick(dropdownRef, () => {
    if (activeIndex === index) {
      setActiveIndex(null)
    }
  })

  useEffect(() => {
    const handleScrollOrResize = () => {
      if (activeIndex === index) {
        setActiveIndex(null)
      }
    }

    const tableContainer = document.querySelector('.overflow-x-auto')

    if (tableContainer) {
      tableContainer.addEventListener('scroll', handleScrollOrResize)
    }

    window.addEventListener('scroll', handleScrollOrResize)
    window.addEventListener('resize', handleScrollOrResize)

    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener('scroll', handleScrollOrResize)
      }
      window.removeEventListener('scroll', handleScrollOrResize)
      window.removeEventListener('resize', handleScrollOrResize)
    }
  }, [activeIndex, index, setActiveIndex])

  return (
    <div className="relative group">
      <img
        src={icon}
        alt="Actions"
        onClick={toggleDropdown}
        className={`
        h-5 w-5 cursor-pointer p-1 rounded-full
        transition-all duration-150 ease-in-out
        group-hover:ring-2 group-hover:ring-gray-300
        ${activeIndex === index ? 'ring-2 ring-gray-300 bg-gray-100' : ''}
      `}
      />

      {activeIndex === index &&
        createPortal(
          <div
            ref={dropdownRef}
            className="absolute bg-white border border-solid border-gray-300 rounded shadow-md z-50"
            style={{
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              padding: '8px 12px',
              minWidth: '160px',
            }}
          >
            {actions.map((action, actionIndex) => (
              <button
                key={actionIndex}
                disabled={disabled}
                className={`
                flex items-center w-full text-left cursor-pointer px-4 py-2
                text-[16px] font-montserrat hover:bg-gray-100 bg-transparent border-none
                ${action.className}
              `}
                onClick={() => {
                  action.onClick()
                  setActiveIndex(null)
                }}
              >
                {action.icon && <action.icon className="h-4 w-4 mr-2" />}
                {action.label}
              </button>
            ))}
          </div>,
          document.body,
        )}
    </div>
  )
}

export default ActionButton
